import { render, staticRenderFns } from "./DashboardVentasEficiencia.vue?vue&type=template&id=2e2e40f6&scoped=true&lang=pug"
import script from "./DashboardVentasEficiencia.vue?vue&type=script&lang=js"
export * from "./DashboardVentasEficiencia.vue?vue&type=script&lang=js"
import style0 from "./DashboardVentasEficiencia.vue?vue&type=style&index=0&id=2e2e40f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2e40f6",
  null
  
)

export default component.exports